import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TPhone(props) {
  const { answers, getJson } = props;
  const categoryId = 1;
  const type = "TPhone";

  useEffect(() => {
    if (answers.length <= 0) {
      getJson({ categoryId, type, answers: [{ selected: "" }] });
    }
  }, [answers, getJson]);

  return <TextField disabled type="text" label="(999)-999-9999" />;
}

TPhone.propTypes = {
  answers: PropTypes.array.isRequired,
  getJson: PropTypes.func,
};
